var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7408 5.50356C18.5372 4.73801 17.9348 4.13408 17.1683 3.9271C15.7825 3.55566 10.2224 3.55566 10.2224 3.55566C10.2224 3.55566 4.66506 3.55566 3.27644 3.9271C2.51284 4.13124 1.91044 4.73518 1.70398 5.50356C1.3335 6.8929 1.3335 9.79348 1.3335 9.79348C1.3335 9.79348 1.3335 12.6941 1.70398 14.0834C1.90761 14.8489 2.51001 15.4529 3.27644 15.6599C4.66506 16.0313 10.2224 16.0313 10.2224 16.0313C10.2224 16.0313 15.7825 16.0313 17.1683 15.6599C17.9319 15.4557 18.5343 14.8518 18.7408 14.0834C19.1113 12.6941 19.1113 9.79348 19.1113 9.79348C19.1113 9.79348 19.1113 6.8929 18.7408 5.50356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4463 12.4672L13.0647 9.79348L8.4463 7.11973V12.4672Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.6b7e4a59e8f695ac104577dc11efc461.svg";
export { ForwardRef as ReactComponent };